import { createContext, useContext, type PropsWithChildren } from "react";
import type { ConfigurationApi } from "../data/ConfigurationApi";

const Context = createContext<ConfigurationApi | null>(null);
export function ConfigurationProvider({ api, children }: PropsWithChildren<{ api: ConfigurationApi }>) {
  return <Context.Provider value={api}>{children}</Context.Provider>;
}
export function useConfigurationApi(): ConfigurationApi {
  const api = useContext(Context);
  if (!api) throw new Error("ConfigurationProvider is required");
  return api;
}
